module.exports = __webpack_public_path__ + "static/media/italiano_icona_insegnante.e608f1ec.png";